import { withStyles } from '@material-ui/core/styles';
import InputBase from '@material-ui/core/InputBase';
import grey from '@material-ui/core/colors/grey';

const drawerWidth = 500;

export const BootstrapInput = withStyles(theme => ({
  // root: {
  //   height: 41,
  //   'label + &': {
  //     marginTop: theme.spacing(3),
  //   },

  // },
  input: {
    position: 'relative',
    width: '100%',
    fontFamily: 'Kanit',
    fontSize: 14,
    transition: theme.transitions.create(['border-color', 'box-shadow']),
  },
}))(InputBase);

// const useStyles = makeStyles((theme) => ({
export const styles = theme => ({
  breakpoints: {
    xs: 0, sm: 375, md: 768, lg: 1024, xl: 1920,
  },
  topDevice: {
    [theme.breakpoints.down('xs')]: {
      marginTop: '100px',
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: '78px',
    },
    [theme.breakpoints.up(1024)]: {
      marginTop: '100px',
      marginLeft: theme.spacing(8),
      marginRight: theme.spacing(8),
    },
    [theme.breakpoints.up(1160 + theme.spacing(3) * 2)]: {
      marginTop: '100px',
    },
  },
  layout: {
    justifyContent: 'space-around',
    width: 'auto',

    [theme.breakpoints.down('xs')]: {
      // marginLeft: theme.spacing(2),
      // marginRight: theme.spacing(2),
    },
    [theme.breakpoints.down('sm')]: {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
    },
    [theme.breakpoints.up(1160 + theme.spacing(3) * 2)]: {
    // [theme.breakpoints.up(1160)]: {
      // width: 1160,
      marginLeft: theme.spacing(2 * 4),
      marginRight: theme.spacing(2 * 4),
    },
  },
  sectionSidebar: {
    position: 'sticky',
    top: 100,
    // left: 5,
    zIndex: 18,
  },
  titleTH: {
    fontFamily: theme.typography.fontKanit,
    fontSize: '1.3rem',
    fontWeight: 500,
    color: '#000',
    lineHeight: '30px',
    paddingLeft: '10px',
  },
  titleEN: {
    fontFamily: theme.typography.fontKanit,
    fontSize: '0.85rem',
    fontWeight: 400,
    color: grey[600],
    lineHeight: '100%',
    paddingLeft: '10px',
  },
  titleTHMobile: {
    fontFamily: theme.typography.fontKanit,
    fontSize: '1.2rem',
    fontWeight: 400,
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
  },
  buttonNavbar: {
    fontFamily: theme.typography.fontKanit,
    fontSize: '0.9rem',
    fontWeight: 400,
  },
  buttonSelectProvinces: {
    color: theme.palette.primary.main,
    fontFamily: theme.typography.fontKanit,
    fontSize: '18px !important',
    fontWeight: 500,
    // paddingLeft: theme.spacing(2),
    // paddingRight: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      fontSize: '14px',
      height: 26,
      padding: theme.spacing(1, 2),
    },
  },
  buttonMenu: {
    padding: 0,
    [theme.breakpoints.down('xs')]: {
      marginLeft: '16px',
    },
  },
  controlProvinces: {
    fontFamily: 'Kanit',
    fontSize: '1rem',
    color: '#555',
  },
  affected: {
    flip: false,
    textAlign: 'right',
  },
  listSelectProvinces: {
    fontSize: '18px',
    [theme.breakpoints.down('xs')]: {
      fontSize: '20px !important',
    },
  },
  root: {
    display: 'flex',
  },

  appBar: {
    backgroundColor: '#fff',
    borderBottom: `4px solid ${theme.palette.primary.main}`,
    borderColor: theme,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    [theme.breakpoints.down('xs')]: {
      height: 70,
    },
    [theme.breakpoints.down('sm')]: {
      // height: 65,
      // paddingRight: theme.spacing(4),
    },
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginRight: drawerWidth,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),

  },

  selectProvinces: {
    fontFamily: 'Kanit',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    border: '1px solid #ccc',
    borderRadius: '30px',
    textAlign: 'center',
    fontSize: '20px',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      padding: theme.spacing(0),
    },
    [theme.breakpoints.up('md')]: {
      marginLeft: theme.spacing(4),
      // marginRight: theme.spacing(4),
    },
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-start',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginRight: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: 0,
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('lg')]: {
      display: 'flex',
    },
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('lg')]: {
      display: 'none',
    },
  },
  imgLogo: {
    marginTop: 10,
    [theme.breakpoints.down('xs')]: {
      maxWidth: 75,
      // marginLeft: theme.spacing(2),
      // marginRight: theme.spacing(2),
    },
    [theme.breakpoints.only('sm')]: {
      maxWidth: 140,
      // marginLeft: theme.spacing(2),
      // marginRight: theme.spacing(2),
    },
    [theme.breakpoints.only('md')]: {
      maxWidth: 130,
      // marginLeft: theme.spacing(2),
      // marginRight: theme.spacing(2),
    },
    [theme.breakpoints.up('lg')]: {
      width: '160px',
      // marginLeft: 'auto',
      // marginRight: 'auto',
    },
  },
  list: {
    width: 320,
  },
  fullList: {
    width: 'auto',
  },
  langTag: {
    fontFamily: 'Kanit',
    fontSize: '0.6em',
  },
  lang: {
    fontFamily: 'Kanit',
    color: '#666',
  },
  pdpaPopupLink: {
    border: '1px solid #ccc',
    borderRadius: '50px',
    padding: '2px 10px',
    color: '#333',
    fontSize: '0.9em',
  },
});
